import { BitfStrapiModel } from '@common/libs/bitforce/core/models';

export class Revenue extends BitfStrapiModel {
  type: string;
  firstYear: number;
  total: number;

  constructor(data: Partial<Revenue> = {}) {
    super({ data });
  }

  get serialised() {
    return {};
  }
}
